'use client';

import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  migrateHashRouteToPath,
  navigateHrmPage,
  pageToPath,
  pathToPage,
  registerHrmNavigator,
} from '@/lib/hrm-routing';

export function useHrmNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = pathToPage(location.pathname);

  const goTo = useCallback(
    (pageOrPath: string) => {
      if (pageOrPath.startsWith('/') || pageOrPath.includes('?')) {
        navigate(pageOrPath.startsWith('/') ? pageOrPath : pageToPath(pageOrPath));
        return;
      }
      navigate(pageToPath(pageOrPath));
    },
    [navigate],
  );

  useEffect(() => {
    registerHrmNavigator(goTo);
    return () => registerHrmNavigator(null);
  }, [goTo]);

  useEffect(() => {
    const migrated = migrateHashRouteToPath();
    if (migrated) {
      goTo(migrated);
    }
  }, [goTo]);

  return { currentPage, goTo, location, navigateHrmPage };
}
